<template>
  <v-carousel
    class=main--text
    height="100%"
    cycle
    hide-delimiter-background
    show-arrows-on-hover>
    <v-carousel-item>
      <v-sheet
        color="white"
        :height="sheetHeight">
        <v-container
          class="no--vertical--paddings"
          fluid>
          <v-row>
            <v-col
              class="no--vertical--paddings"
                cols=12
                md=4>
              <v-container
                fluid>
                <v-row
                  justify=center>
                  <v-col
                    cols=8
                    sm=6
                    md=auto>
                    <v-img
                      alt="No Images"
                      max-height=260
                      max-width=260
                      :src="osanaiImage"></v-img>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              class="no--vertical--paddings"
              cols=12
              md=8>
              <v-container
                fluid>
                <v-row
                  justify=center
                  justiy-md=start
                  align=end>
                  <v-col
                    cols=12
                    md=auto
                    class="black--text no--vertical--paddings"><h2>小山内 美悠</h2></v-col>
                  <v-col
                    class="black--text no--vertical--paddings"><h4>Miyu Osanai</h4></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col
                    class="black--text"
                    justify=center
                    jusitfy-md=start>
                    東京大学農学部卒業。<br>
                    学生時代は個別指導塾で数多くの小中学生の学習を指導。<br>
                    大学卒業後はIT企業での内定者・新入社員研修を企画。メンターとしても、一人ひとりにきめ細やかなフィードバックを行う。<br>
                    社外においても、ITエンジニアの合同勉強会を主催し、講師として登壇もしており、指導・講義経験は豊富。<br>
                    IT系資格試験の問題作成等にも携わっており、「学ぶ側」の視点を熟知した指導が持ち味。
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        color="white"
        :height="sheetHeight">
        <v-container
          class="no--vertical--paddings"
          fluid>
          <v-row
            >
            <v-col
              class="no--vertical--paddings"
                cols=12
                md=4>
              <v-container
                fluid>
                <v-row
                  justify=center>
                  <v-col
                    cols=8
                    sm=6
                    md=auto>
                    <v-img
                      alt="No Images"
                      max-height=260
                      max-width=260
                      :src="kajimaImage"></v-img>
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
            <v-col
              class="no--vertical--paddings"
              cols=12
              md=8>
              <v-container
                fluid>
                <v-row
                  justify=center
                  justiy-md=start
                  align=end>
                  <v-col
                    cols=12
                    md=auto
                    class="black--text no--vertical--paddings"><h2>梶間 悠平</h2></v-col>
                  <v-col
                    class="black--text no--vertical--paddings"><h4>Yuhei Kajima</h4></v-col>
                </v-row>
                <v-divider></v-divider>
                <v-row>
                  <v-col
                    class="black--text"
                    justify=center
                    jusitfy-md=start>
                    東京大学文学部卒業。<br>
                    学生時代は個別指導塾・家庭教師・大手受験予備校アシスタントを経験し、様々な教育現場、そして子どもたちと出会う。<br>
                    これからの時代に通用するものづくりができる人間になることを志し、金融業界からITエンジニアに転身。このProsenseのサービス開発にも携わる。<br>
                    プログラミングの指導では、自らがイチから学んだ経験と、教育現場で得た知見をフル活用。わかりやすく、そして楽しい学習を常に追求している。
                  </v-col>
                </v-row>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-carousel-item>
    <v-carousel-item>
      <v-sheet
        color="white"
        :height="sheetHeight">
        <v-container
          fill-height>
          <v-row
            justify=center>
            <v-col
              cols=auto
              class="black--text">
              <h2>And more...</h2>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import OsanaiImage from '@/assets/img/osanai.jpg'
import KajimaImage from '@/assets/img/kajima.jpg'
export default {
  data: () => {
    return {
      osanaiImage: OsanaiImage,
      kajimaImage: KajimaImage
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown
    },
    sheetHeight() {
      return (this.isMobile) ? 660 : 310
    }
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}

.img-wrapper {
  justify-content: center
}
</style>
